/* PDP "You May Also Like" data sources for sw-inventory-tabs.
   Similar watches come from Shopify's recommendations API (watches only),
   ranked by price, brand and case size. Recently viewed comes from
   localStorage and is fetched as individual product cards. */
(function () {
  const STORAGE_KEY = 'sw:recently-viewed';
  const MAX_STORED = 12;

  function readRecent() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecent(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.filter(Boolean).slice(0, MAX_STORED)));
    } catch (error) {
      /* Storage can be unavailable in private browsing. */
    }
  }

  function remember(host) {
    if (host.dataset.swRemembered) return;
    host.dataset.swRemembered = 'true';
    const handle = host.dataset.handle;
    if (!handle) return;
    const rest = readRecent().filter((item) => item !== handle);
    saveRecent([handle, ...rest]);
  }

  function extras(host) {
    const template = host.querySelector('[data-sw-rec-fallback]');
    if (!template) return [];
    return Array.from(template.content.children).filter((node) => node.matches('li'));
  }

  function score(item, host, related) {
    const price = Number(item.dataset.price);
    const basePrice = Number(host.dataset.price);
    const size = parseFloat(item.dataset.size);
    const baseSize = parseFloat(host.dataset.size);
    let value = price > 0 && basePrice > 0 ? Math.abs(Math.log(price / basePrice)) : 1;
    if (item.dataset.vendor !== host.dataset.vendor) value += 0.4;
    if (size > 0 && baseSize > 0) value += Math.min(Math.abs(size - baseSize), 12) * 0.05;
    if (related) value -= 0.1;
    return value;
  }

  window.SwInventorySources = window.SwInventorySources || {};

  window.SwInventorySources.related = async function related(_tab, host) {
    remember(host);
    let items = [];
    try {
      const response = await fetch(host.dataset.recUrl, { credentials: 'same-origin' });
      if (response.ok) {
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        items = Array.from(doc.querySelectorAll('[data-sw-rec-results] > li'));
      }
    } catch (error) {
      items = [];
    }

    const seen = new Set([host.dataset.handle]);
    const pool = [];
    [...items.map((item) => [item, true]), ...extras(host).map((item) => [item, false])].forEach(([item, related]) => {
      const handle = item.dataset.swRecHandle;
      if (!handle || seen.has(handle)) return;
      if (item.dataset.type === 'travel' || item.dataset.vendor === 'icebox') return;
      seen.add(handle);
      pool.push({ item, score: score(item, host, related) });
    });
    return pool.sort((a, b) => a.score - b.score).map((entry) => entry.item);
  };

  window.SwInventorySources.recent = async function recent(tab, host) {
    remember(host);
    const exclude = tab.dataset.exclude || host.dataset.handle;
    const handles = readRecent().filter((handle) => handle !== exclude);
    if (!handles.length) return [];

    const base = host.dataset.cardUrl || '/products/';
    const results = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`${base}${encodeURIComponent(handle)}?section_id=sw-product-card-item`, {
            credentials: 'same-origin',
          });
          if (!response.ok) return { handle, item: null, gone: response.status === 404 };
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return { handle, item: doc.querySelector('li[data-sw-rec-handle]') };
        } catch (error) {
          return { handle, item: null };
        }
      })
    );

    const gone = results.filter((result) => result.gone).map((result) => result.handle);
    if (gone.length) saveRecent(readRecent().filter((handle) => !gone.includes(handle)));
    return results.map((result) => result.item).filter(Boolean);
  };
})();
